import React from 'react';
import { LogoImg } from './elements';
import { PageWrapper, Container } from '@Main/elements';
import { P } from '@helpers';
import bg from '@static/about/sfx-bg_4.png';

export const Contionous = ({t}) => {
    return (
      <PageWrapper darkMode={true} bgImage={bg} height="450px">
        <Container paddingTop='35px' marginLeft='102px' marginRight='35px'>
          <LogoImg/>
          <P weight='400' size='25px' height='30px' marginTop='30px'>{t("Continuous growth")}</P>
          <P weight='400' size='15px' height='30px' marginTop='40px' width="700px">
            {t(`However, we always strive to exceed customers’ expectations by performing continuous innovation and supporting our clients on every step of their journey. Making an impact on our customers’ business is a big privilege for our constantly growing team. That is why we offer many consulting services, to make these clients top players among their competitors.`)}
          </P>
        </Container>
     </PageWrapper>
  );
};
